import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseAreLeadershipManagementFlightsEnabled = () => boolean;
export const useAreLeadershipManagementFlightsEnabled: UseAreLeadershipManagementFlightsEnabled = () => {
  const isLeadershipManagementTreatmentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.LeadershipManagement) === true;
  const isVivaEngagePremiumTreatmentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium) === true;

  return isLeadershipManagementTreatmentEnabled || isVivaEngagePremiumTreatmentEnabled;
};
